import React, { Component } from 'react'

export class Categories extends Component {
    constructor(props) {
        super(props)
        this.state = {
          categories: [
            {
              key: "all",
              name: "Все",
            },
            {
              key: "piano",
              name: "Піаніно",
            },
            {
              key: "digital_piano",
              name: "Цифрове піаніно",
            },
            {
              key: "synthesizer",
              name: "Синтезатор",
            },
            {
              key: "royal",
              name: "Рояль",
            },
            {
              key: "guitar",
              name: "Гітара",
            },
            {
              key: "drums",
              name: "Барабани",
            },
          ],
        };
    } 
  render() {
    return (
      <div className='categories'>
            {this.state.categories.map(el => (
                <div key={el.key} onClick={() => this.props.chooseCategory(el.key)}>
                    {el.name}
            </div>
        ))}
      </div>
    )
  }
}

export default Categories
